import Breadcrumb from "./index.vue";

Breadcrumb.install = Vue => Vue.component(Breadcrumb.componentName, Breadcrumb);

export default Breadcrumb;
